module.exports = __webpack_public_path__ + "img/p2-79.67948edd.png";